export default "__VITE_ASSET__DgiUyeq7__"